const Homedata=
    [
        {
            id:'1',
            image:"https://m.media-amazon.com/images/I/415xRYxXTpL._AC_UX385_.jpg"
        },
        {
            id:'2',
            image:"https://m.media-amazon.com/images/I/91YKb63wdfS._AC_SY355_.jpg"
        },
        {
            id:'3',
            image:"https://m.media-amazon.com/images/I/91+C0dnunPL._AC_UF1000,1000_QL80_FMwebp_.jpg"
        },
        {
            id:'4',
            image:"https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg"
        },
        {
            id:'5',
            image:"https://m.media-amazon.com/images/I/81QpkIctqPL._AC_SX679_.jpg"
        },
     
]

export default Homedata